import React, { Component } from 'react'
import {connect} from 'react-redux'

import { saveNotes, saveNotesFailure, clearAjaxCall } from '../../actions/Notes'

import Modal from '../Modal'

const colors = [
  {value: 'orange', name: 'Arancione'},
  {value: 'deep-orange', name: 'Arancione scuro'},
  {value: 'amber', name: 'Ambra'},
  {value: 'brown', name: 'Marrone'},
  {value: 'blue-grey', name: 'Blu grigio'},
  {value: 'blue', name: 'Blu'},
  {value: 'light-blue', name: 'Blu chiaro'},
  {value: 'yellow', name: 'Giallo'},
  {value: 'lime', name: 'Lime'},
  {value: 'cyan', name: 'Ciano'},
  {value: 'purple', name: 'Porpora'},
  {value: 'deep-purple', name: 'Viola scuro'},
  {value: 'indigo', name: 'Indaco'},
  {value: 'pink', name: 'Rosa'},
  {value: 'red', name: 'Rosso'},
  {value: 'green', name: 'Verde'},
  {value: 'light-green', name: 'Verde chiaro'},
  {value: 'teal', name: 'Verde acqua'}
]

class EditNote extends Component {
  saveNotes () {
    const s = this.state
    if (s.title !== '' && s.message !== '') {
      this.props.saveNotes(s)
    } else {
      this.props.saveNotesFailure('Titolo e nota sono obbligatori')
      setTimeout(() => { this.props.clearAjaxCall('') }, 3000)
    }
  }
  componentWillMount () {
    const i = this.props.note
    const rnd = Math.floor((Math.random() * colors.length))
    this.setState({
      id: i.id,
      title: i.title,
      color: (i.id === null) ? colors[rnd].value : i.color,
      message: i.message,
      share: i.share
    })
  }
  render () {
    const { ajaxStatus } = this.props.notes
    const c = this.state
    return (
      <Modal>
        <h3>{(c.id !== null) ? 'Modifica' : 'Aggiungi'} nota</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <label>
          Colore
          <select
            onChange={event => this.setState({ color: event.target.value })}
            value={c.color}
          >
            {
              colors.map((c, index) => {
                return (
                  <option key={index} value={c.value}>
                    {c.name}
                  </option>
                )
              })
            }
          </select>
          <div className={'cc-prev ' + this.state.color}></div>
        </label>
        <label>
          Titolo
          <input
            type="text"
            placeholder="Nome"
            onChange={event => this.setState({ title: event.target.value })}
            value={c.title}
          />
        </label>
        <label>
          Nota
          <textarea placeholder="Nota"
            onChange={event => this.setState({ message: event.target.value })}
            value={c.message}
            className="area-note"
          ></textarea>
        </label>
        <label>
          Condivisione
          <select
            onChange={event => this.setState({ share: event.target.value })}
            value={c.share}
          >
            <option value={0}>Privata</option>
            <option value={1}>Condivisa</option>
            <option value={2}>Condivisa e modificabile</option>
          </select>
        </label>
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.saveNotes()}
            >
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveNotes, saveNotesFailure, clearAjaxCall })(EditNote)



// WEBPACK FOOTER //
// ./src/components/Notes/EditNote.js